import React, {useState} from "react";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import DocumentalMyDocuments from "./DocumentalMyDocuments";
import DocumentalUploadDocument from "./DocumentalUploadDocument";

const DocumentalStudent = () => {

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        console.log(`Going to tab ${newValue}`);
        setTabValue(newValue);
    };

    function TabPanel(props) {
        return(
            <div role="tabpanel"
                 hidden={tabValue !== props.index}
                 id={`tabpanel-${props.index}`}
                 aria-labelledby={`full-width-tab-${props.index}`}>
                { tabValue === props.index && (
                    <Box>
                        {props.component}
                    </Box>
                )}
            </div>
        )
    }

    return (
        <React.Fragment>
            <AppBar position={"static"}>
                <Tabs variant={"fullWidth"} value={tabValue} onChange={handleTabChange}>
                    <Tab label={"Tus Documentos"} />
                    <Tab label={"Subir Documento"} />
                </Tabs>
            </AppBar>
            <TabPanel index={0} component={DocumentalMyDocuments}/>
            <TabPanel index={1} component={DocumentalUploadDocument}/>
        </React.Fragment>
    )
}

export default DocumentalStudent